<template>
<div>
	<el-form :model="changeForm" ref="changeFormRef" :rules="changeFormRules" :label-position="formSet.label" label-width="120px" :size="formSet.size">
	    <el-form-item label="销售订单号:" prop="vbeln" v-if="!pageData.isBatch">
	        <el-input v-model="changeForm.vbeln" disabled></el-input>
	    </el-form-item>
		<el-form-item label="未开票原因:" v-if="pageType==1" prop="vatOverdueDesc">
        <el-select
          v-model="changeForm.vatOverdueDesc"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in vatOverdueDescOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
			</el-select>
	    </el-form-item>
	    <el-form-item label="未回款原因:" v-if="pageType==2" prop="backOverdueDesc">
        <el-select
          v-model="changeForm.backOverdueDesc"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in backOverdueDescOptions"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
			</el-select>
	    </el-form-item>
	    <el-form-item label="预计开票日期:" v-if="pageType==1" prop="predictVatDat">
        <el-date-picker
          v-model="changeForm.predictVatDat"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          style="width: 100%"
        ></el-date-picker>
	    </el-form-item>
	    <el-form-item label="预计回款日期:" v-if="pageType==2" prop="predictBackDat">
        <el-date-picker
          v-model="changeForm.predictBackDat"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          style="width: 100%"
        ></el-date-picker>
	    </el-form-item>
	    <el-form-item label="首次跟进人:" prop="firstFollower">
	        <el-input v-model="changeForm.firstFollower" disabled></el-input>
	    </el-form-item>
	    <el-form-item label="当前跟进人:" prop="creator">
	        <el-input v-model="changeForm.creator" disabled></el-input>
	    </el-form-item>
    <el-form-item label="协同邮件:" filterable>
      <el-select
          v-model="changeForm.email"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="getEmailList"
      >
        <el-option value="" label="不发送邮件"></el-option>
        <el-option
            v-for="(item, index) in emailList"
            :key="index"
            :label="item"
            :value="item"
        >
        </el-option>
      </el-select>
    </el-form-item>
	    <el-form-item label="备注说明:" prop="feedbackRemark">
	        <el-input v-model="changeForm.feedbackRemark" type="textarea"></el-input>
	    </el-form-item>
	    <el-form-item label="重复订单:" prop="repeatOrderNumber" v-if="showRepeatOrderFields">
	        <el-input v-model="changeForm.repeatOrderNumber" placeholder="若是重复做单，请填写重复订单的link单号；不是则不填"></el-input>
	    </el-form-item>
	    <el-form-item label="是否有客户证明:" prop="hasCustomerProof" v-if="showRepeatOrderFields">
	        <el-radio v-model="changeForm.hasCustomerProof" :label="1">有</el-radio>
	        <el-radio v-model="changeForm.hasCustomerProof" :label="0">无</el-radio>
	    </el-form-item>
		<el-form-item :label="showRepeatOrderFields && changeForm.hasCustomerProof === 1 ? '上传图片:' : '上传图片:'" prop="imageUrls" :required="showRepeatOrderFields && changeForm.hasCustomerProof === 1">
			<div class="img-uploader" v-if="changeForm.imageUrls && changeForm.imageUrls.length">
				<div class="el-upload" v-for="(item, index) in changeForm.imageUrls" :key="index">
					<img :src="item" class="img" />
					<span class="delete" @click.stop="uploadImgDelete(index)">
						<i class="el-icon-delete"></i>
					</span>
				</div>
			</div>
			<!-- 调用 uploadAction：公网改写为 /open/api/reqorder/upload -->
			<el-upload
				v-if="changeForm.imageUrls && changeForm.imageUrls.length < 5"
				class="img-uploader"
				:action="uploadAction"
				accept="image/*"
				:headers="{user_login_token: $store.state.token}"
				:show-file-list="false"
				:before-upload="beforeImgUpload"
				:on-success="uploadImgSuccess">
				<i class="el-icon-plus img-uploader-icon"></i>
			</el-upload>
		</el-form-item>
      <el-form-item label-width="0" style="text-align: center">
			<el-button type="primary" @click="submitChangeForm()">提交</el-button>
			<el-button @click="changeFlag(false)">关闭</el-button>
	    </el-form-item>
	</el-form>
</div>
</template>
<script>
import {
  RMS_VAT_OVERDUE_DESC_OPTIONS,
  RMS_BACK_OVERDUE_DESC_OPTIONS,
  isCustomerCancelOrReturnReason,
} from "../../common/rmsOverdueDesc";
import { isBmsOpenHost } from "../../utils/openApi";
export default {
	name: "RMSFeedback",
	props: ["pageData"],
	data() {
		return {
      nickName: sessionStorage.getItem("NICKNAME"),
			pageType: 1,
      vatOverdueDescOptions: RMS_VAT_OVERDUE_DESC_OPTIONS,
      backOverdueDescOptions: RMS_BACK_OVERDUE_DESC_OPTIONS,
			formSet: {
        label: "right",
        size: "small",
			},
			changeForm: {
				id: "",
				vbeln: "",
				vatOverdueDesc: "",
				backOverdueDesc: "",
				predictVatDat: "",
				predictBackDat: "",
				firstFollower: "",
				creator: "",
				email: "",
				feedbackRemark: "",
				imageUrls: [],
				repeatOrderNumber: "",
				hasCustomerProof: "",
			},
			// 表单验证
			changeFormRules: {
				vatOverdueDesc: [
					{ required: true, message: "请填写未开票原因", trigger: "blur" },
				],
				backOverdueDesc: [
					{ required: true, message: "请填写未回款原因", trigger: "blur" },
				],
				predictVatDat: [
					{ required: true, message: "请选择日期", trigger: "blur" },
				],
				predictBackDat: [
					{ required: true, message: "请选择日期", trigger: "blur" },
				],
				// firstFollower: [
				// 	{ required: true, message: "请填写首次跟进人", trigger: "blur" },
				// ],
				creator: [
					{ required: true, message: "请填写当前跟进人", trigger: "blur" },
				],
				feedbackRemark: [
					{ required: true, message: "请填写备注说明", trigger: "blur" },
				],
				hasCustomerProof: [
					{ 
						validator: (rule, value, callback) => {
							if (this.showRepeatOrderFields) {
								if (value === "" || value === null || value === undefined) {
									callback(new Error("请选择是否有客户证明"));
								} else {
									callback();
								}
							} else {
								callback();
							}
						}, 
						trigger: "change" 
					},
				],
				imageUrls: [
					{ 
						validator: (rule, value, callback) => {
							if (this.showRepeatOrderFields && this.changeForm.hasCustomerProof === 1) {
								if (!value || value.length === 0) {
									callback(new Error("客户证明选择有，请上传图片"));
								} else {
									callback();
								}
							} else {
								callback();
							}
						}, 
						trigger: "change" 
					},
				],
			},
			changeFormFlag: {
				vatOverdueDesc: false,
				backOverdueDesc: false,
				predictVatDat: false,
				predictBackDat: false,
			},
      emailList: [],
		};
	},
	computed: {
		// 当未开票/未回款原因选择「客户取消/退货」时显示重复订单和是否有客户证明
		showRepeatOrderFields() {
			return isCustomerCancelOrReturnReason(this.changeForm.vatOverdueDesc)
				|| isCustomerCancelOrReturnReason(this.changeForm.backOverdueDesc);
		},
		/**
		 * 反馈图片上传地址。公网 bms-open 走 /open/api/reqorder/upload，内网保持原路径。
		 * 调用处：模板 el-upload 的 action。
		 */
		uploadAction() {
			const base = (this.$http && this.$http.defaults && this.$http.defaults.baseURL) || '';
			const path = isBmsOpenHost() ? '/open/api/reqorder/upload' : '/reqorder/upload';
			return base + path;
		},
	},
	created() {
		if(this.pageData.clientType=="mobile"){ //手机
      this.formSet.label = "top";
      this.formSet.size = "mini";
    }
		this.init();
	},
	methods: {
		/**
		 * 反馈弹框可编辑字段：每次打开清空，不沿用列表行或上次填写内容。
		 */
		resetEditableFeedbackFields() {
			this.changeForm.vatOverdueDesc = '';
			this.changeForm.backOverdueDesc = '';
			this.changeForm.predictVatDat = '';
			this.changeForm.predictBackDat = '';
			this.changeForm.email = '';
			this.changeForm.feedbackRemark = '';
			this.changeForm.imageUrls = [];
			this.changeForm.repeatOrderNumber = '';
			this.changeForm.hasCustomerProof = '';
			for (let item in this.changeFormFlag) {
				this.changeFormFlag[item] = false;
			}
		},
		/**
		 * 反馈弹框只读字段：从 pageData 带入，对应表单项 disabled，需保留订单行数据。
		 */
		applyReadonlyFieldsFromPageData() {
			this.changeForm.vbeln = this.pageData.vbeln || '';
			this.changeForm.id = this.pageData.id != null && this.pageData.id !== '' ? this.pageData.id : '';
			this.changeForm.firstFollower = this.pageData.firstFollower || this.nickName;
			this.changeForm.creator = this.nickName;
		},
		/**
		 * 打开反馈弹框：可编辑项重置，disabled 只读项仍从订单行带入。
		 */
		resetChangeFormForOpen() {
			// 调用 resetEditableFeedbackFields：原因/日期/备注/图片等每次重新填写
			this.resetEditableFeedbackFields();
			// 调用 applyReadonlyFieldsFromPageData：销售单号、首次/当前跟进人等 disabled 字段保留
			this.applyReadonlyFieldsFromPageData();
			this.$nextTick(() => {
				if (this.$refs.changeFormRef) {
					this.$refs.changeFormRef.clearValidate();
				}
			});
		},
		// 初始化
		init(){
      this.getEmailList();
			this.pageType = this.pageData.type;
			// 调用 resetChangeFormForOpen：区分只读带入与可编辑字段
			this.resetChangeFormForOpen();
		},
		// 图片上传-验证
		beforeImgUpload(file) {
			const isJPG = file.name.substring(file.name.lastIndexOf(".") + 1) === "jpg";
			const isJPEG = file.name.substring(file.name.lastIndexOf(".") + 1) === "jpeg";
			const isPNG = file.name.substring(file.name.lastIndexOf(".") + 1) === "png";
			const isBMP = file.name.substring(file.name.lastIndexOf(".") + 1) === "bmp";
			const isGIF = file.name.substring(file.name.lastIndexOf(".") + 1) === "gif";
			const isLt2M = file.size / 1024 / 1024 < 2;
		
			if (!isJPG && !isJPEG && !isPNG && !isBMP && !isGIF) {
				this.$message.error("图片只能是 jpg、jpeg、png、bmp、gif 格式!");
			} else if (!isLt2M) {
				this.$message.error("图片大小不能超过 2MB!");
      }
			return (isJPG || isJPEG || isPNG || isBMP || isGIF) && isLt2M;
		},
		// 图片上传-返回
		uploadImgSuccess(res, file) {
			if (res.code==200) {
				this.changeForm.imageUrls.push(res.result.url);
				return true;
      }
			this.$message({
				message: res.message,
				type: "error",
			});
		},
		// 图片上传-删除
		uploadImgDelete(index){
			this.changeForm.imageUrls.splice(index, 1);
		},
		// 提交
		async submitChangeForm(){
			this.$refs.changeFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        
        // 手动验证：当显示重复订单字段且客户证明选择"有"时，必须上传图片
        if (this.showRepeatOrderFields && this.changeForm.hasCustomerProof === 1) {
          if (!this.changeForm.imageUrls || this.changeForm.imageUrls.length === 0) {
            this.$message({
              type: "warning",
              message: "客户证明选择有，请上传图片",
            });
            return;
          }
        }

        let res2 = "";

        if (this.pageData.isBatch) {
          //批量反馈
          if (!this.pageData.params) {
						this.$message({
              type: "warning",
              message: "无可反馈订单",
            });
            return;
          }
          res2 = await this.$api.receivableSubmitFeedback(
            {
              ...this.changeForm,
              ...this.pageData.params,
            }
          );
        } else {
          let vbelns = [];
          vbelns.push(this.changeForm.vbeln)
          res2 = await this.$api.receivableSubmitFeedback({
            ...this.changeForm,
            vbelns: vbelns,
          });
        }

        if (res2.code == 200) {
          this.$message({
            type: "success",
            message: "成功",
						});
						this.changeFlag(true);
        }
			});
		},
		// 关闭弹窗
		changeFlag(flag){
      this.$emit("successFeedback", flag);
		},
    async getEmailList() {
      let res = await this.$http.post("/receivable/getEmailList", {});
      if (res.code == 200) {
        this.emailList = res.result;
      } else {
        this.emailList = [];
      }
    },
  },
};
</script>
<style lang="less" scoped>
.img-uploader {
	display: inline-block;
	vertical-align: top;
	/deep/.el-upload {
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		margin-bottom: 10px;
		margin-right: 10px;
		&:hover {
			.delete {
				display: block;
			}
		}
	}
	.img {
		display: block;
		width: 80px;
		height: 80px;
	}
	.delete {
		height: 24px;
		line-height: 24px;
		padding: 0 5px;
		font-size: 16px;
		color: #fff;
		background: rgba(0,0,0,0.5);
		position: absolute;
		top: 0;
		right: 0;
		display: none;
	}
	.img-uploader-icon {
		width: 80px;
		height: 80px;
		line-height: 80px;
		font-size: 20px;
		color: #8c939d;
		text-align: center;
	}
}
/deep/.el-form-item--mini {
	.el-form-item__label {
		padding-bottom: 0;
	}
}
</style>
